import {config} from "../../config.js";
import {get, post, put} from "../../services/httpAdmin.js";
import {formatDateForDb} from "../../services/utilities.js";

export let getOrder = async function (id) {
  // probably not used. can delete?
  return await get(`${config.apiUrl}/order/id/${id}`);
};

export let getOrderDetails = async function (id, extraDetails) {
  let data = await get(
    `${config.apiUrl}/order/id/${id}?extra-details=${extraDetails}`
  );
  return data;
};

export let activeOrders = async function (page, limit) {
  return await get(
    `${config.apiUrl}/orders?active=1&limit=${limit}&page=${page}`
  );
};

export let searchOrders = async function (query) {
  return await get(`${config.apiUrl}/orders?query=${query}`);
};

export let getOrdersBySku = async function (sku, limit = 10) {
  return await get(
    `${config.apiUrl}/orders?sku=${encodeURIComponent(sku)}&limit=${limit}`
  );
};

export let getStatusCountActive = async function () {
  return await get(`${config.apiUrl}/orders/count?active=1`);
};

export let getStatusCountInactive = async function () {
  return await get(`${config.apiUrl}/orders/count?active=0`);
};

export let getOrdersByStatus = async function (status, page, limit) {
  return await get(
    `${config.apiUrl}/orders/status/${status}?page=${page}&limit=${limit}`
  );
};

export let getOrdersByUserId = async function (userId) {
  let body = JSON.stringify({user_id: userId})
  return await post(
    `${config.apiUrl}/admin/orders/user`,
    body,
    "application/json",
    true,
  );
};

export let pendingOrders = async function () {
  return await get(`${config.apiUrl}/orders/status/2`);
};

export let rentalOrders = async function () {
  return await get(`${config.apiUrl}/orders/status/16`);
};

export let lateOrders = async function () {
  return await get(`${config.apiUrl}/orders/status/7`);
};

export let orderStatuses = async function () {
  let data = await get(`${config.apiUrl}/orders/statuses`);
  // format the data so its easy to get by status
  let obj = {};
  data.forEach((x) => {
    let status = x.status;
    obj[status] = x;
  });
  return obj;
};

export let updateStatus = async function (oldStatus, newStatus, orderID) {
  let body = JSON.stringify({
    order_id: parseInt(orderID),
    start_id: parseInt(oldStatus),
    end_id: parseInt(newStatus),
  });
  return await post(
    `${config.apiUrl}/orders/status`,
    body,
    "application/json",
    false
  );
};

export let addNote = async function (orderID, notes) {
  let body = JSON.stringify({ notes });
  return await post(
    `${config.apiUrl}/orders/audit/${orderID}`,
    body,
    "application/json",
    false
  );
};

export let getOrderHistory = async function (orderID) {
  return await get(`${config.apiUrl}/orders/audit/${orderID}`);
};

export let chargeLateFee = async function (orderID) {
  try {
    return await post(
      `${config.apiUrl}/charges/latefee/${orderID}`,
      JSON.stringify({}),
      null,
      false
    );
  } catch (err) {
    return false;
  }
};

export let updateReturnDate = async function (orderID, newDate) {
  try {
    return await put(
      `${config.apiUrl}/order/id/${orderID}`,
      JSON.stringify({
        update: true,
        rental_return_time: formatDateForDb(newDate),
      }),
      null,
      false
    );
  } catch (err) {
    return false;
  }
};

export let returnItem = async function (product, quantity) {
  try {
    return await put(
      `${config.apiUrl}/orders/item/${product.order_product_id}`,
      JSON.stringify({
        quantity,
      }),
      null,
      false
    );
  } catch (err) {
    return false;
  }
};

export let exportOrders = async function (from, to) {
  try {
    let queryParams = [];
    // convert dates to rfc-3339 format
    if (from) {
      from = new Date(from);
      queryParams.push(`from=${from.toISOString()}`);
    }
    if (to) {
      to = new Date(to);
      to.setUTCHours(23, 59, 59, 999);
      queryParams.push(`to=${to.toISOString()}`);
    }

    let url = `${config.apiUrl}/export?type=orders&`;

    if (queryParams) {
      url += queryParams.join("&");
    }

    return await post(url, JSON.stringify({}), "text/csv", true);
  } catch (err) {
    return false;
  }
};

export let addOrderItems = async function (orderId, products) {
  let body = JSON.stringify({
    products,
  });
  return await post(
    `${config.apiUrl}/orders/${orderId}/items`,
    body,
    "application/json",
    true
  );
};

export let exportOrderItems = async function (from, to) {
  try {
    let queryParams = [];
    // convert dates to rfc-3339 format
    if (from) {
      from = new Date(from);
      queryParams.push(`from=${from.toISOString()}`);
    }
    if (to) {
      to = new Date(to);
      to.setUTCHours(23, 59, 59, 999);
      queryParams.push(`to=${to.toISOString()}`);
    }

    let url = `${config.apiUrl}/export?type=order_items&`;

    if (queryParams) {
      url += queryParams.join("&");
    }

    return await post(url, JSON.stringify({}), "text/csv", true);
  } catch (err) {
    return false;
  }
};

export let exportPurchasedItems = async function (from, to) {
  try {
    let queryParams = [];
    // convert dates to rfc-3339 format
    if (from) {
      from = new Date(from);
      queryParams.push(`from=${from.toISOString()}`);
    }
    if (to) {
      to = new Date(to);
      to.setUTCHours(23, 59, 59, 999);
      queryParams.push(`to=${to.toISOString()}`);
    }

    let url = `${config.apiUrl}/export?type=order_items_accounting&`;

    if (queryParams) {
      url += queryParams.join("&");
    }

    return await post(url, JSON.stringify({}), "text/csv", true);
  } catch (err) {
    return false;
  }
};

export let createOrder = async function (
  selectedUser,
  email,
  description,
  orderType,
  orderComplete,
  taxesInt,
  products,
  sendReceipt,
  giftCardAmountCents = 0,
  discountPercent = 0
) {
  let custId = selectedUser ? selectedUser.sub : "";
  // set either to confirmed (3) or complete (11) for now
  let orderStatus = orderComplete ? 11 : 3;
  let body = JSON.stringify({
    email,
    customer_id: custId,
    products,
    description,
    order_type: orderType,
    status_id: orderStatus,
    taxes: taxesInt,
    send_receipt: sendReceipt,
    gift_card_amount: giftCardAmountCents,
    discount_percent: discountPercent,
  });
  return await post(`${config.apiUrl}/orders`, body, "application/json", true);
};
